import { forwardRef, useState } from 'react';
import IdNameDto from '@src/adapters/dto/shared/IdNameDto';
import {
  Autocomplete,
  AutocompleteChangeReason,
  SxProps,
  TextField,
  Theme,
} from '@mui/material';

interface Props {
  items: IdNameDto[];
  selectedItem: IdNameDto | null;
  sx?: SxProps<Theme>;
  selection: (selectedItem: any | null) => void;
}

const SuggestionAutoComplete = forwardRef<HTMLDivElement, Props>(
  function SuggestionAutoComplete({ items, selectedItem, selection, sx }, ref) {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
      setOpen(false);
    };

    const handleOpen = () => {
      setOpen(true);
    };

    const handleChange = (
      _: React.SyntheticEvent,
      data: any | null,
      reason: AutocompleteChangeReason
    ) => {
      selection(data);
    };

    return (
      <Autocomplete
        ref={ref}
        noOptionsText="No options available"
        selectOnFocus
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        value={selectedItem}
        options={items}
        onChange={handleChange}
        sx={sx ? sx : undefined}
        isOptionEqualToValue={(option, value) => {
          if (!value || !option) {
            return false;
          }
          return option.name === value.name;
        }}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          if (typeof option === 'object' && option.name) {
            return option.name;
          }
          return '';
        }}
        renderInput={(params) => (
          <TextField {...params} label={'Scanned Text'} />
        )}
        renderOption={(props, option) => (
          <li {...props} key={option.id}>
            {option.name}
          </li>
        )}
      />
    );
  }
);

export default SuggestionAutoComplete;
